// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-1e99e8bd] {\n  padding: 24px 12px 6px 0;\n}\n.translation-row[data-v-1e99e8bd] {\n  align-items: baseline;\n}\n.translation-row .label[data-v-1e99e8bd] {\n  text-align: right;\n  padding-right: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
